import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import ArticleBundleItem from "../article-bundle-item";
import { fetchOtherDomainCollection } from "../../../api";
import styles from "./styles.m.css";

const SpecialBundleCard = ({
  className = "",
  config = {},
  myvikatanwidget = false,
  userType = "F",
  limit: customLimit
}) => {
  const collectionSlug = "audiobooks-audio-series-bundle-desktop";
  const pageNumber = 0;
  // const limit = 5;
  // Use custom limit if passed, else fallback logic
  const limit =
    customLimit !== undefined
      ? customLimit
      : userType === "P" || userType === "T" || userType === "R"
        ? 7
        : myvikatanwidget
          ? 7
          : 5;
  const [collections, setData] = useState([]);
  useEffect(() => {
    fetchOtherDomainCollection(collectionSlug, pageNumber, limit, {}, "collection").then(response => {
      setData(response["items"]);
    });
  }, []);

  return (
    <div className={`${styles["base"]} ${className}`}>
      <div className={styles["collections-wrap-header"]}>
        <a href="/vikatan-play" target="_blank" rel="noopener noreferrer">
          <img
            alt="Vikatan"
            src="https://media.vikatan.com/vikatan/2025-06-10/g8o9cvez/Vikatanplaylogo.png?format=webp&w=300&q=100"
            className={styles["brand-logo"]}
            width="78px"
            height="49px"
          />
        </a>
        <h2>விகடனின் கிளாசிக் படைப்புகள் இப்போது ஆடியோ புத்தகங்களாக!</h2>
      </div>
      <div className={styles["collections-wrap-section"]}>
        {collections && (
          <div className={styles["collections-wrap"]}>
            {collections.map(
              collection =>
                collection && (
                  <ArticleBundleItem
                    key={collection.id}
                    collection={collection}
                    className={styles["collection-item"]}
                    config={config}
                  />
                )
            )}
          </div>
        )}
      </div>
    </div>
  );
};

SpecialBundleCard.propTypes = {
  className: PropTypes.string,
  config: PropTypes.shape(),
  myvikatanwidget: PropTypes.bool,
  userType: PropTypes.string,
  limit: PropTypes.number
};

export default SpecialBundleCard;
